<template>
  <div class="list-container">
    <div class="page-inner">
      <div class="page-header">
        <div>
          <h1 class="page-title">新闻管理</h1>
        </div>
        <button class="add-button" type="button" @click="openAddDialog">
          + 新增新闻
        </button>
      </div>

      <div class="news-list" v-if="newsList.length">
        <div
          class="news-item"
          v-for="(item, index) in newsList"
          :key="item.id || index"
        >
          <div class="cover">
            <img v-if="item.imgUrl" :src="item.imgUrl" alt="" />
            <div v-else class="cover-empty">暂无封面</div>
          </div>
          <div class="meta">
            <div class="title">{{ item.newsTitle }}</div>
            <div class="time">创建时间：{{ item.createTime }}</div>
          </div>
          <div class="actions">
            <button type="button" class="action-btn" @click="editNews(item.id)">
              编辑
            </button>
            <button
              type="button"
              class="action-btn danger"
              @click="toDelete(item.id)"
            >
              删除
            </button>
          </div>
        </div>
      </div>
      <div v-else class="empty-tip">暂无新闻，点击右上角新增</div>

      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalCount"
          :page-size="pageSize"
          :current-page="pageNum"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      custom-class="news-editor-dialog"
      :title="editFlag ? '编辑新闻' : '新增新闻'"
      :visible.sync="newsDialog"
      width="100%"
      top="0"
      fullscreen
      :close-on-click-modal="false"
      append-to-body
      @closed="handleDialogClosed"
    >
      <div v-if="newsDialog" class="editor-layout">
        <div class="preview-panel">
          <div class="preview-shell">
            <div class="preview-nav">
              首页 &gt; 关于焱图 &gt; 焱图动态 &gt;
              <span class="nav-current">{{
                ruleForm.newsTitle || "新闻标题"
              }}</span>
            </div>
            <input
              class="preview-title-input"
              v-model="ruleForm.newsTitle"
              placeholder="请输入新闻标题"
            />
            <div class="preview-time">{{ previewTime }}</div>

            <div class="preview-editor">
              <Toolbar
                class="preview-toolbar"
                :editor="editor"
                :defaultConfig="toolbarConfig"
                :mode="mode"
              />
              <Editor
                class="preview-editor-body"
                v-model="ruleForm.newsContent"
                :defaultConfig="editorConfig"
                :mode="mode"
                @onCreated="onCreated"
              />
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="newsDialog = false">取 消</el-button>
        <el-button type="primary" :loading="saving" @click="publishNews">
          {{ editFlag ? "保存更新" : "发布新闻" }}
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="删除新闻"
      :visible.sync="deleteDialog"
      width="420px"
      center
      append-to-body
    >
      <div class="delete-tip">确定要删除该新闻吗？删除后不可恢复。</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="danger" @click="toDeleteNews">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import {
  addNews,
  updateNews,
  getNewsList,
  deleteNews,
  getNewsDetail,
  uploadImg,
} from "../util/api.js";

export default {
  components: { Editor, Toolbar },
  data() {
    return {
      newsDialog: false,
      editor: null,
      toolbarConfig: {},
      deleteDialog: false,
      saving: false,
      editorConfig: {
        placeholder: "在此编辑正文，图片与排版效果接近前台详情页…",
        MENU_CONF: {
          uploadImage: {
            customUpload: (file, insertFn) => {
              uploadImg(file)
                .then((response) => {
                  const imageUrl = response.data.data;
                  insertFn(imageUrl, "图片描述", imageUrl);
                })
                .catch((error) => {
                  console.error("图片上传失败", error);
                  this.$message.error("图片上传失败");
                });
            },
          },
        },
      },
      mode: "default",
      ruleForm: {
        newsContent: "",
        newsTitle: "",
      },
      totalCount: 0,
      pageSize: 20,
      pageNum: 1,
      newsList: [],
      editFlag: false,
      deleteId: "",
    };
  },
  computed: {
    previewTime() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor);
      if (this.ruleForm.newsContent) {
        editor.setHtml(this.ruleForm.newsContent);
      }
    },

    openAddDialog() {
      this.editFlag = false;
      this.clearData();
      this.newsDialog = true;
    },

    handleDialogClosed() {
      if (this.editor) {
        this.editor.destroy();
        this.editor = null;
      }
      this.editFlag = false;
      this.saving = false;
      this.clearData();
    },

    publishNews() {
      if (!this.ruleForm.newsTitle || !this.ruleForm.newsTitle.trim()) {
        this.$message.warning("请填写新闻标题");
        return;
      }
      const content = (this.ruleForm.newsContent || "")
        .replace(/<p><br><\/p>/g, "")
        .trim();
      if (!content) {
        this.$message.warning("请填写新闻正文");
        return;
      }

      this.saving = true;
      const request = this.editFlag
        ? updateNews(this.ruleForm)
        : addNews(this.ruleForm);
      request
        .then((res) => {
          if (res.data.status == "success") {
            this.$message.success(this.editFlag ? "更新成功" : "发布成功");
            this.newsDialog = false;
            this.getList();
          } else {
            this.$message.error(res.data.message || "操作失败");
          }
        })
        .catch(() => {
          this.$message.error("操作失败，请稍后重试");
        })
        .finally(() => {
          this.saving = false;
        });
    },

    clearData() {
      this.ruleForm = {
        id: "",
        newsTitle: "",
        newsContent: "",
      };
    },

    getList() {
      getNewsList(this.pageSize, this.pageNum).then((res) => {
        if (res.data.status == "success") {
          res.data.data.newsList.map((item) => {
            item.imgUrl = this.extractFirstImageUrl(item.newsContent);
            item.createTime = this.formatDate(item.createTime);
          });
          this.newsList = res.data.data.newsList;
          this.totalCount = res.data.data.total;
        }
      });
    },

    extractFirstImageUrl(htmlString) {
      const imgRegex = /<img.*?src="(.*?)"/;
      const match = htmlString && htmlString.match(imgRegex);
      if (match && match[1]) {
        return match[1];
      }
      return "";
    },

    formatDate(isoDateString) {
      if (!isoDateString) return "";
      const date = new Date(isoDateString);
      if (Number.isNaN(date.getTime())) return isoDateString;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    toDeleteNews() {
      deleteNews(this.deleteId).then((res) => {
        if (res.data.status == "success") {
          this.deleteDialog = false;
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getList();
        }
      });
    },

    toDelete(id) {
      this.deleteId = id;
      this.deleteDialog = true;
    },

    editNews(id) {
      getNewsDetail(id).then((res) => {
        if (res.data.status == "success") {
          const newsData = res.data.data;
          this.editFlag = true;
          this.ruleForm = {
            id: newsData.id,
            newsTitle: newsData.newsTitle || "",
            newsContent: newsData.newsContent || "",
          };
          this.newsDialog = true;
        }
      });
    },

    handleCurrentChange(index) {
      this.pageNum = index;
      this.getList();
    },
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy();
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="stylus" scoped>
.list-container
  min-height 100vh
  padding 100px 24px 48px
  box-sizing border-box
  background #f5f7fb

.page-inner
  max-width 960px
  margin 0 auto

.page-header
  display flex
  align-items flex-start
  justify-content space-between
  gap 16px
  margin-bottom 20px

.page-title
  margin 0
  font-size 24px
  font-weight 600
  color #1f2a37

.page-subtitle
  margin 6px 0 0
  font-size 13px
  color #8a94a6

.add-button
  border 0
  border-radius 8px
  padding 10px 18px
  background #2372E9
  color #fff
  font-size 14px
  cursor pointer
  white-space nowrap
  transition background 0.2s

  &:hover
    background #1b5fc7

.news-list
  display flex
  flex-direction column
  gap 12px

.news-item
  display flex
  align-items center
  gap 16px
  padding 14px 16px
  background #fff
  border 1px solid #e8edf5
  border-radius 12px
  transition box-shadow 0.2s, border-color 0.2s

  &:hover
    border-color #c9d8f5
    box-shadow 0 6px 18px rgba(35, 114, 233, 0.08)

.cover
  width 148px
  height 84px
  flex-shrink 0
  overflow hidden
  border-radius 8px
  background #eef2f8

  img
    width 100%
    height 100%
    object-fit cover
    display block

.cover-empty
  width 100%
  height 100%
  display flex
  align-items center
  justify-content center
  color #9aa5b5
  font-size 12px

.meta
  flex 1
  min-width 0

  .title
    font-size 16px
    font-weight 600
    color #243044
    line-height 1.4
    overflow hidden
    text-overflow ellipsis
    white-space nowrap

  .time
    margin-top 8px
    font-size 13px
    color #8a94a6
    line-height 1.4

.actions
  display flex
  gap 8px
  flex-shrink 0

.action-btn
  border 1px solid #d7e3f8
  background #f3f8ff
  color #2372E9
  border-radius 6px
  padding 6px 12px
  font-size 13px
  cursor pointer

  &:hover
    background #e8f1ff

  &.danger
    border-color #f3d2d2
    background #fff5f5
    color #d64545

    &:hover
      background #ffecec

.empty-tip
  padding 48px 0
  text-align center
  color #9aa5b5
  background #fff
  border-radius 12px
  border 1px dashed #d9e2f0

.pagination
  margin-top 24px
  display flex
  justify-content center

.delete-tip
  color #4a5568
  line-height 1.6

.editor-layout
  display flex
  flex-direction column
  height calc(100vh - 130px)
  min-height 0

.preview-panel
  flex 1
  min-height 0
  overflow auto
  background #fff
  border-radius 8px

.preview-shell
  // 与新闻详情页一致：max-width:var(--main-width); width:84%
  max-width var(--main-width)
  width 84%
  margin 0 auto
  padding 40px 0 32px
  box-sizing border-box

.preview-nav
  color #999
  font-size 0.88rem
  margin-bottom 2rem

  .nav-current
    color #2372E9

.preview-title-input
  width 100%
  border 0
  outline none
  font-size 2rem
  font-weight 500
  color #333
  line-height 1.35
  background transparent
  padding 0
  margin-bottom 1.25rem

  &::placeholder
    color #c5cad3

.preview-time
  margin 0 0 1.25rem
  color #999
  padding-bottom 1.25rem
  border-bottom 1px solid #EBEBEB
  font-size 14px

.preview-editor
  border 1px solid #edf0f5
  border-radius 8px
  overflow hidden
  display flex
  flex-direction column
  min-height calc(100vh - 360px)

.preview-toolbar
  border-bottom 1px solid #edf0f5 !important
  flex-shrink 0

.preview-editor-body
  flex 1
  height auto !important
  min-height calc(100vh - 420px) !important
  overflow-y auto !important

  /deep/ .w-e-text-container
    background #fff
    height 100% !important

  /deep/ .w-e-scroll
    padding 4px 0 !important

  // 与新闻详情页正文样式对齐
  /deep/ .w-e-text-container [data-slate-editor]
    padding 8px 4px !important
    color #333
    font-size 1rem
    line-height 1.8
    word-break break-word
    min-height calc(100vh - 460px) !important

  /deep/ .w-e-text-container p
    margin 0.75rem 0
    line-height 1.8

  /deep/ .w-e-text-container img
    display block
    max-width 100% !important
    width auto !important
    height auto !important
    margin 1rem auto
    object-fit contain

@media (max-width: 768px)
  .list-container
    padding 88px 12px 32px

  .page-header
    flex-direction column

  .news-item
    flex-wrap wrap

  .cover
    width 100%
    height 160px

  .actions
    width 100%
    justify-content flex-end

  .preview-shell
    width calc(100% - 30px)
    padding 24px 0

  .preview-title-input
    font-size 1.375rem

  .preview-editor
  .preview-editor-body
    min-height 50vh !important
</style>

<style lang="stylus">
.news-editor-dialog.el-dialog.is-fullscreen
  display flex
  flex-direction column
  margin 0 !important
  max-width none
  width 100% !important
  height 100% !important
  border-radius 0

  .el-dialog__header
    position relative
    padding 14px 28px 10px
    flex-shrink 0
    border-bottom 1px solid #eef1f6

  .el-dialog__headerbtn
    top 50%
    right 24px
    width 40px
    height 40px
    margin-top 0
    transform translateY(-50%)

  .el-dialog__close
    font-size 28px !important
    font-weight 600
    color #4a5568
    line-height 40px
    display inline-block
    width 40px
    height 40px
    text-align center

    &:hover
      color #2372E9

  .el-dialog__title
    font-size 18px
    font-weight 600
    color #1f2a37

  .el-dialog__body
    flex 1
    min-height 0
    padding 12px 64px
    background #f5f7fb
    overflow hidden

  .el-dialog__footer
    flex-shrink 0
    padding 12px 28px 16px
    background #fff
    border-top 1px solid #eef1f6
</style>
